export class LoadMoreComponent {
    // Selectors
    private readonly profilesContainer = '.js-show-more-list';
    private readonly showMoreTriggerContainerSelector = '.js-show-more-trigger-container';
    private readonly showMoreTriggerSelector = '.js-show-more-trigger';

    // Elements
    private actionElement: HTMLButtonElement;

    private baseUrl: string;

    public init(): void {
        this.baseUrl = this.getBaseUrl();
        this.actionElement = document.querySelector(this.showMoreTriggerSelector) as HTMLButtonElement;
        if (this.actionElement) {
            this.initLoadMoreMode();
        } else {
            console.warn('No load more button found.');
        }
    }

    private getBaseUrl(): string {
        const elementWithBaseUrl: HTMLElement = document.querySelector('[data-base-url]');
        return elementWithBaseUrl.dataset.baseUrl;
    }

    public updateCompaniesList(searchParams: string): Promise<any> {
        return this.loadMoreElements(`${this.baseUrl}${searchParams}`, true);
    }

    private initLoadMoreMode(): void {
        this.addLoadMoreTrigger();
    }

    private loadMoreElements(url: string, reset = false): Promise<any> {
        this.toggleButtonLoadingState();
        return fetch(url)
            .then((response) => {
                this.toggleButtonLoadingState();
                if (!response.ok) {
                    throw new Error(`Status code: ${response.status} - ${response.statusText}`);
                }
                return response.json();
            })
            .then((data) => {
                if (data?.ajaxPagination?.nextPage === null) {
                    this.hideLoadMoreButtonContainer();
                } else {
                    this.showLoadMoreButtonContainer();
                }

                if (data.ajaxPagination.nextPage !== null) {
                    this.updateNextPageUrl(data.ajaxPagination.nextPage);
                }

                if (data?.html) {
                    const profileContainer = document.querySelector(this.profilesContainer);
                    if (reset) {
                        profileContainer.innerHTML = data.html;
                    } else {
                        profileContainer.insertAdjacentHTML('beforeend', data.html);
                    }
                }

                return data;
            });
    }

    private toggleButtonLoadingState(): void {
        if (this.actionElement) {
            if (this.actionElement.classList.contains('btn-arrow')) {
                this.actionElement.classList.remove('btn-arrow', 'btn-arrow-down');
                this.actionElement.classList.add('btn-loading');
                this.actionElement.disabled = true;
            } else {
                this.actionElement.disabled = false;
                this.actionElement.classList.remove('btn-loading');
                this.actionElement.classList.add('btn-arrow', 'btn-arrow-down');
            }
        }
    }

    private hideLoadMoreButtonContainer() {
        const button: HTMLDivElement = document.querySelector(this.showMoreTriggerContainerSelector);
        if (button && !button.classList.contains('d-none')) {
            document.querySelector(this.showMoreTriggerContainerSelector).classList.add('d-none');
        }
    }

    private updateNextPageUrl(nextPage: string) {
        if (this.actionElement) {
            this.actionElement.dataset.nextPageUrl = nextPage;
        }
    }

    private addLoadMoreTrigger() {
        this.actionElement.addEventListener('click', () => {
            const nextPageDataAttribute = this.actionElement.dataset.nextPageUrl;
            if (nextPageDataAttribute) {
                void this.loadMoreElements(nextPageDataAttribute);
            }
        });
    }

    private showLoadMoreButtonContainer() {
        const button: HTMLDivElement = document.querySelector(this.showMoreTriggerContainerSelector);
        if (button && button.classList.contains('d-none')) {
            document.querySelector(this.showMoreTriggerContainerSelector).classList.remove('d-none');
        }
    }
}
